import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";
import { currencyFormatter } from "src/utils/common";

type TopProductPoint = {
  name: string;
  totalSales: number;
};

interface TopProductsChartProps {
  data: TopProductPoint[];
}

const TopProductsChart: React.FC<TopProductsChartProps> = ({ data }) => {
  return (
    <div className="mt-4 h-52 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#E5E7EB" vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 11 }}
            interval={0}
            angle={-20}
            textAnchor="end"
            height={50}
          />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              borderColor: "#E5E7EB",
              fontSize: "12px",
            }}
            labelStyle={{ fontWeight: 600 }}
            formatter={(value?: number) =>
              currencyFormatter(value || 0, "IN", 2)
            }
          />
          <Bar dataKey="totalSales" fill="#86EFAC" radius={[8, 8, 8, 8]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopProductsChart;
